import React, { useCallback, useEffect, useState } from 'react';
import { KTSVG } from '../../_metronic/helpers';
import GoogleCalendar from '../../assets/image/Google.svg';
import OutlookCalendar from '../../assets/image/outlook.svg';
import moment from 'moment';
import { addEventCalendar, GetAccountEmployeeTimeEntryCustomFields, gettimesheetData, updateCustomFieldFalg, updateEventFalg } from './CalendarSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { GetCalendarEventsForNotification } from '../../common/GlobalSlice';
import { getValueFromResource } from '../../common/timeLiveFunction';
import { useTranslation } from 'react-i18next';

type Props = {
    position: { top: number; left: number };
    event: any;
    IsAdd?:boolean;
    onClose: () => void;
    onSave: (newEvent: any) => void;
};

const ExternalEventPopover: React.FC<Props> = ({ position, event,IsAdd= false, onClose, onSave }) => {
    const { googleConnected, outlookConnected } = useAppSelector((state) => state.calendar);
    const { accountFeatureList } = useAppSelector((state) => state.globalState);
    const showTimesheet = accountFeatureList?.some((item: any) => item?.Id === 'db17deb7-51a0-4400-bf3b-9094e01ef038') ?? false;
    const imageURL = event?.extendedProps?.type === 'outlook';
    const AccountId = localStorage.getItem('accountId');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { title, url, start, end, source, id, extendedProps } = event;
    const [adjustedPosition, setAdjustedPosition] = useState(position)
    const currentDate = moment().format('YYYY-MM-DD')

    useEffect(() => {
        const popoverWidth = 300
        const popoverHeight = 200
        const margin = 10

        let { top, left } = position
        if (left + popoverWidth > window.innerWidth) {
            left = window.innerWidth - popoverWidth - margin
        }
        if (left < margin) {
            left = margin
        }

        if (top + popoverHeight > window.innerHeight + window.scrollY) {
            top = position.top - popoverHeight - 5
        }
        if (top < window.scrollY + margin) {
            top = window.scrollY + margin
        }

        setAdjustedPosition({ top, left })
    }, [position])

    const dispatchEvent = useCallback(
        (calendarType: number) => {
            dispatch(
                addEventCalendar({
                    CalendarTypeId: calendarType,
                    AccountId,
                    AccountEmployeeId,
                    EventName: title,
                    Description: extendedProps?.Description,
                    StartTime: moment(start).format('YYYY-MM-DDTHH:mm:ss'),
                    EndTime: moment(end).format('YYYY-MM-DDTHH:mm:ss'),
                    EventDate: moment(start).format('YYYY-MM-DD'),
                    StartDate: moment(start).format('YYYY-MM-DD'),
                    EndDate: moment(end).format('YYYY-MM-DD'),
                    SystemReminderTimeId: 1,
                    ExternalReferenceId: id,
                    SyncDirection: 'OutBound',
                    CreatedByEmployeeId: AccountEmployeeId,
                    SystemReminderTypeId: 2,
                    EventLink: url,
                    StartTimeZone: extendedProps?.StartTimeZone,
                    EndTimeZone: extendedProps?.EndTimeZone,
                })
            );
        },
        [dispatch, title, start, end, url, id, extendedProps, AccountId, AccountEmployeeId]
    );

    const handleCopyEvent = async () => {
        const calendarType = extendedProps?.type === 'google' ? 2 : extendedProps?.type === 'outlook' ? 3 : null;
        if (!calendarType) return;

        if (googleConnected?.InBound === true && calendarType === 2) {
            await dispatchEvent(calendarType);
            dispatch(updateEventFalg(true));
            if (moment(event?.start).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD')) {
                dispatch(GetCalendarEventsForNotification(currentDate))
            }
        }

        if (outlookConnected?.InBound === true && calendarType === 3) {
            await dispatchEvent(calendarType);
            dispatch(updateEventFalg(true));
            if (moment(event?.start).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD')) {
                dispatch(GetCalendarEventsForNotification(currentDate))
            }
        }

        onClose();
    };

    const handleSaveAsTimeEntry = () => {
        if (AccountEmployeeId) {
            const currentDate = moment(start).format('YYYY-MM-DD');
            const endDate = moment(end).format('YYYY-MM-DD');
            const obj = { AccountEmployeeId, currentDate, endDate }
            dispatch(gettimesheetData(obj))
        }
        dispatch(GetAccountEmployeeTimeEntryCustomFields())
        dispatch(updateCustomFieldFalg(true));
        onSave(event);
    }

    const handlePopoverClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div
            style={{
                position: 'absolute',
                top: adjustedPosition.top + 40,
                left: adjustedPosition.left,
                // top: position.top + 40,
                // left: position.left,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                width: '300px',
                zIndex: 9999,
                transition: "top 0.2s ease, left 0.2s ease",
            }}
            // onClick={(e) => e.stopPropagation()}
            onClick={handlePopoverClick}
            onMouseDown={handlePopoverClick}
        >
            <div
                className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom"
                style={{ backgroundColor: '#FFF', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}
            >
                <div className="d-flex align-items-center gap-2">
                   {IsAdd && <i
                        className="bi bi-files fs-5 p-1 cursor-pointer iconColor"
                        data-tooltip-id="tooltip-ExternalEvent"
                        data-tooltip-content={getValueFromResource('Save as event', dispatch, t)}
                        onClick={handleCopyEvent}
                    ></i>}
                    {showTimesheet && (
                        <i
                            className="bi bi-file-text fs-5 p-1 cursor-pointer iconColor"
                            data-tooltip-id="tooltip-ExternalEvent"
                            data-tooltip-content={getValueFromResource('Save as time entry', dispatch, t)}
                            onClick={handleSaveAsTimeEntry}
                        ></i>
                    )}

                    <i
                        className="bi bi-box-arrow-up-right fs-5 iconColor p-1 cursor-pointer"
                        data-tooltip-id="tooltip-ExternalEvent"
                        data-tooltip-content={getValueFromResource('Open in calendar', dispatch, t)}
                        onClick={() => window.open(event?.url, '_blank')}
                    ></i>
                </div>

                <button
                    className="btn btn-sm btn-icon btn-light"
                    onClick={onClose}
                    style={{ border: 'none' }}
                >
                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                </button>
            </div>

            <div className="p-3">
                {/* <div className="bg-success bg-opacity-10 text-success px-4 py-2 rounded text-center fw-semibold mb-3">
                    Timelive Calendar Interface Update
                </div> */}
                <div
                    className="px-4 py-2 rounded text-center fw-semibold mb-3"
                    style={{
                        backgroundColor: event?.extendedProps?.type === 'google'
                            ? googleConnected.ColorCode + "1A"
                            : event?.extendedProps?.type === 'outlook'
                                ? outlookConnected.ColorCode + "1A"
                                : "#1987541A",
                        color: event?.extendedProps?.type === 'google'
                            ? googleConnected.ColorCode
                            : event?.extendedProps?.type === 'outlook'
                                ? outlookConnected.ColorCode
                                : "#198754",
                    }}
                >
                    {event?.title}
                </div>
                <div className="d-flex gap-2 mx-auto" style={{ width: 'max-content' }}>
                    <div className="d-flex flex-column align-items-start my-2">
                        <div className='my-2'>
                            <span
                                className="bg-success rounded-circle"
                                style={{ width: '10px', height: '10px' }}
                            ></span>
                            <span className="fw-bold text-dark">{event?.extendedProps?.OrganizerEmail}</span>
                        </div>
                        <div className='d-flex align-items-center gap-2 text-muted'>
                            <i className="bi bi-clock"></i>
                            <span>
                                {new Date(event.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} →
                                {' '}
                                {new Date(event.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </span>
                        </div>
                    </div>
                    <div className="">
                        <img
                            src={imageURL ? OutlookCalendar : GoogleCalendar}
                            alt="Google Calendar"
                            width={50}
                            height={50}
                            style={{ marginLeft: '8px', border: '1px solid #eee', position: 'relative', top: '9px' }}
                        />
                    </div>
                </div>
            </div>

            <ReactTooltip
                id="tooltip-ExternalEvent"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 10000
                }}
                place="top"
            />
        </div>
    );
};

export default ExternalEventPopover;
